module.exports = __webpack_public_path__ + "bathroom.png?67d6e54d6fe8f018e6afd37bda1b62b5";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/bathroom.png
// module id = 496
// module chunks = 0